import {Reservation, ReservationApartment} from './reservation.model';
import {CheckInFlowData, completedCheckIns, pendingCheckIns} from './check-in-flow.model';

export interface Checkin {
  id: number;
  entry_date: string;
  TYPE: string;
  STREET_ADDRESS: string;
  EXPIRY: string;
  EXPEDITION_DATE: string;
  TEST_GLOBAL_AUTHENTICITY_RATIO: string;
  NAME: string;
  CITY_ADDRESS: string;
  postal_code: string;
  municipality_id: number;
  province_id: number;
  family_relationship_type_id: number | null;
  EXPEDITOR: string;
  BIRTHDATE: string;
  NATIONALITY: string;
  NATIONALITY_ISO3: string;
  ID_NUMBER: string | null;
  DOC_NUMBER: string | null;
  STATE_ADDRESS: string;
  TEST_GLOBAL_AUTHENTICITY_VALUE: string;
  SEX: string;
  SURNAME: string;
  FIRST_SURNAME: string;
  SECOND_SURNAME: string;
  MODEL_ID: string;
  DOC_IMG_FRONT: string | null;
  DOC_IMG_BACK: string | null;
  DOC_PHOTO: string | null;
  DOC_SIGN: string | null;
  reservation_id: number;
  icar_verified: number;
  created_at: string;
  updated_at: string;
  ownerContractFileUrl: string | null;
  travelRegisterFileUrl: string | null;
  part_of_traveler_number: string | null;
  travel_part_txt: string | null;
  travelRegisterId: string;
  checkin_signed: number;
  signature_image: string | null;
  email: string;
  contractUrl: string;
}

export function hasCheckIn(apartment: ReservationApartment): boolean {
  return apartment.has_check_in == 1;
}

export function checkinRequiredForOpen(reservation: Reservation): boolean {
  return reservation.data.trust == 0
    ;
}

export function checkInRequiredAndNoOneCheckedIn(flow: CheckInFlowData, reservation: Reservation): boolean {
  if (!hasCheckIn(reservation.data.apartment)) {
    return false;
  }
  return completedCheckIns(flow) == 0;
}


export function checkInRequiredAndNotEveryoneCheckedIn(flow: CheckInFlowData, reservation: Reservation): boolean {
  if (!hasCheckIn(reservation.data.apartment)) {
    return false;
  }

  return pendingCheckIns(flow) > 0;
}
